// extracted by mini-css-extract-plugin
export default {"footer":"vMvjnAlzgmtgYGo9LWzC","action":"FCwnmzHBeM6ryQdHWbKc"};